export default {
  SET_KPI_SUMMARY(state, data) {
    state.kpiSummary = data;
  },
  SET_REVENUE_OVER_TIME(state, data) {
    state.revenueOverTime = data;
  },
  SET_PEAK_HOURS(state, data) {
    state.peakHours = data;
  },
  SET_PRODUCT_PERFORMANCE(state, data) {
    state.productPerformance = data;
  },
  SET_ORDER_SOURCES(state, data) {
    state.orderSources = data;
  },
  SET_PAYMENT_METHODS(state, data) {
    state.paymentMethods = data;
  },
  SET_CUSTOMER_STATS(state, data) {
    state.customerStats = data;
  },
  SET_OPERATIONS(state, data) {
    state.operations = data;
  },
  SET_ORDER_LOCATIONS(state, data) {
    state.orderLocations = data;
  },
  SET_REVENUE_BY_PAYMENT(state, data) {
    state.revenueByPayment = data;
  },
  SET_WEEKDAY_HEATMAP(state, data) {
    state.weekdayHeatmap = data;
  },
  SET_AVG_ORDER_VALUE(state, data) {
    state.avgOrderValue = data;
  },
  SET_REVENUE_BY_AREA(state, data) {
    state.revenueByArea = data;
  },
  SET_NEW_VS_RETURNING(state, data) {
    state.newVsReturning = data;
  },
  SET_POPULAR_INGREDIENTS(state, data) {
    state.popularIngredients = data;
  },
  SET_ADDRESS_MAP(state, data) {
    state.addressMap = data;
  },
};
